// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Images/crane_login.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    display: flex;
    min-height: 100vh;
    background-color: var(--primary-grey);
  }
  
  .login-left {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    /* background-color: var(--primary-grey); */
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    position: relative;
  }
  .login-left::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6); /* Adjust the last value (0.6) for overlay darkness */
    z-index: 1;
  }
  .login-content {
    text-align: center;
    color: #fff;
    max-width: 400px;
    position: relative;
  z-index: 2;
  }
  
  .login-logo {
    height: 60px;
    /* margin-bottom: 2rem; */
  }
  input:focus, select:focus, textarea:focus {
    
    border-color: unset;
    box-shadow: unset;
  }
  
  .login-content h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    color: var(--primary-yellow);
  }
  
  .login-content p {
    font-size: 1.1rem;
    opacity: 0.8;
  }
  
  .login-right {
    flex: 1 1;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  }
  
  .login-form-container {
    width: 100%;
    max-width: 400px;
    padding: 2rem;
  }
  
  .login-form-container h2 {
    color: var(--primary-grey);
    font-size: 1.8rem;
    margin-bottom: 2rem;
  }
  .pswd_div .eye_icn {
    right: -27px;
  }
  .form-group {
    margin-bottom: 1.5rem;
    width: 100%;
    position: relative;
    margin-bottom: var(--spacing-md) !important;
  }
  .MuiTextField-root {
    width: 100%;
  }
  
  .input-group {
    position: relative;
    display: flex;
    align-items: center;
  }
  .labl_div label{
    left: 0px;
  } 
  .pswd_div .MuiInputBase-input:focus {
    border-color: none !important;
  }
  .form-group i {
    position: absolute;
    top: 20px;
    left: 1rem;
    color: var(--secondary-grey);
  }
  .form-group label {
    background-color: #fff;
  }
  
  .input-group input {
    width: 100%;
    padding: 1rem 1rem 1rem 3rem;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;
  }
  
  /* .input-group input:focus {
    border-color: var(--primary-yellow);
    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);
    outline: none;
  } */
  
  .password-toggle {
    position: absolute;
    right: 1rem;
    cursor: pointer;
  }
  
  .remember-forgot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.9rem;
  }
  
  .remember-me {
    display: flex;
    align-items: center;
    max-width: fit-content;
    white-space: nowrap;
    gap: 0.4rem;
    color: var(--secondary-grey);
  }
  
  .forgot-password {
    /* color: var(--primary-yellow); */
    text-decoration: none;
    transition: opacity 0.3s ease;
    font-weight: 600;
    text-decoration: underline;
  }
  
  .forgot-password:hover {
    opacity: 0.8;
  }
  
  .login-btn {
    width: 100%;
    padding: 1rem;
    background-color: var(--primary-yellow);
    color: var(--primary-grey);
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    transition: all 0.3s ease;
  }
  
  .login-btn:hover {
    opacity: 0.9;
    transform: translateY(-1px);
  }
  .pswd_div .MuiInputAdornment-root , .labl_div .MuiInputAdornment-root {
    margin-right: 28px;
  }
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
  
    box-shadow: none !important;
  }
  .pswd_div .MuiInputBase-root {
    /* padding-left: 0px !important; */
  }
  
  /* Remove any yellow box-shadow on focus */
  .MuiOutlinedInput-root.Mui-focused {
    box-shadow: none !important;
  }
  input:-webkit-autofill,
input:-webkit-autofill:focus,
input:-webkit-autofill:hover,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 1000px #fff inset !important;
  -webkit-text-fill-color: #222 !important;
  caret-color: #222 !important;
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}
  
  @media (max-width: 768px) {
    .login-container {
      flex-direction: column;
    }
  
    .login-left {
      padding: 2rem 1rem;
    }
  
    .login-content h1 {
      font-size: 2rem;
    }
  
    .login-right {
      padding: 1rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPass/ForgetPassword.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,qCAAqC;EACvC;;EAEA;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,2CAA2C;IAC3C,yDAA4D;IAC5D,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC,EAAE,qDAAqD;IAC3F,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB,UAAU;EACV;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;EACA;;IAEE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,SAAO;IACP,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,2CAA2C;EAC7C;EACA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,SAAS;EACX;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;;;;KAIG;;EAEH;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;IAClC,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,0BAA0B;IAC1B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,2BAA2B;EAC7B;EACA;IACE,kBAAkB;EACpB;EACA;;IAEE,2BAA2B;EAC7B;EACA;IACE,kCAAkC;EACpC;;EAEA,0CAA0C;EAC1C;IACE,2BAA2B;EAC7B;EACA;;;;EAKA,8CAA8C;EAC9C,wCAAwC;EACxC,4BAA4B;EAC5B,yDAAiD;EAAjD,iDAAiD;AACnD;;EAEE;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;EACF","sourcesContent":[".login-container {\r\n    display: flex;\r\n    min-height: 100vh;\r\n    background-color: var(--primary-grey);\r\n  }\r\n  \r\n  .login-left {\r\n    flex: 1;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 2rem;\r\n    /* background-color: var(--primary-grey); */\r\n    background-image: url('../../assets/Images/crane_login.jpg');\r\n    background-size: cover;\r\n    background-position: center;\r\n    position: relative;\r\n  }\r\n  .login-left::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.6); /* Adjust the last value (0.6) for overlay darkness */\r\n    z-index: 1;\r\n  }\r\n  .login-content {\r\n    text-align: center;\r\n    color: #fff;\r\n    max-width: 400px;\r\n    position: relative;\r\n  z-index: 2;\r\n  }\r\n  \r\n  .login-logo {\r\n    height: 60px;\r\n    /* margin-bottom: 2rem; */\r\n  }\r\n  input:focus, select:focus, textarea:focus {\r\n    \r\n    border-color: unset;\r\n    box-shadow: unset;\r\n  }\r\n  \r\n  .login-content h1 {\r\n    font-size: 2.5rem;\r\n    margin-bottom: 1rem;\r\n    color: var(--primary-yellow);\r\n  }\r\n  \r\n  .login-content p {\r\n    font-size: 1.1rem;\r\n    opacity: 0.8;\r\n  }\r\n  \r\n  .login-right {\r\n    flex: 1;\r\n    background-color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 2rem;\r\n  }\r\n  \r\n  .login-form-container {\r\n    width: 100%;\r\n    max-width: 400px;\r\n    padding: 2rem;\r\n  }\r\n  \r\n  .login-form-container h2 {\r\n    color: var(--primary-grey);\r\n    font-size: 1.8rem;\r\n    margin-bottom: 2rem;\r\n  }\r\n  .pswd_div .eye_icn {\r\n    right: -27px;\r\n  }\r\n  .form-group {\r\n    margin-bottom: 1.5rem;\r\n    width: 100%;\r\n    position: relative;\r\n    margin-bottom: var(--spacing-md) !important;\r\n  }\r\n  .MuiTextField-root {\r\n    width: 100%;\r\n  }\r\n  \r\n  .input-group {\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  .labl_div label{\r\n    left: 0px;\r\n  } \r\n  .pswd_div .MuiInputBase-input:focus {\r\n    border-color: none !important;\r\n  }\r\n  .form-group i {\r\n    position: absolute;\r\n    top: 20px;\r\n    left: 1rem;\r\n    color: var(--secondary-grey);\r\n  }\r\n  .form-group label {\r\n    background-color: #fff;\r\n  }\r\n  \r\n  .input-group input {\r\n    width: 100%;\r\n    padding: 1rem 1rem 1rem 3rem;\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 8px;\r\n    font-size: 1rem;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  /* .input-group input:focus {\r\n    border-color: var(--primary-yellow);\r\n    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2);\r\n    outline: none;\r\n  } */\r\n  \r\n  .password-toggle {\r\n    position: absolute;\r\n    right: 1rem;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .remember-forgot {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .remember-me {\r\n    display: flex;\r\n    align-items: center;\r\n    max-width: fit-content;\r\n    white-space: nowrap;\r\n    gap: 0.4rem;\r\n    color: var(--secondary-grey);\r\n  }\r\n  \r\n  .forgot-password {\r\n    /* color: var(--primary-yellow); */\r\n    text-decoration: none;\r\n    transition: opacity 0.3s ease;\r\n    font-weight: 600;\r\n    text-decoration: underline;\r\n  }\r\n  \r\n  .forgot-password:hover {\r\n    opacity: 0.8;\r\n  }\r\n  \r\n  .login-btn {\r\n    width: 100%;\r\n    padding: 1rem;\r\n    background-color: var(--primary-yellow);\r\n    color: var(--primary-grey);\r\n    border: none;\r\n    border-radius: 8px;\r\n    font-size: 1rem;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.5rem;\r\n    transition: all 0.3s ease;\r\n  }\r\n  \r\n  .login-btn:hover {\r\n    opacity: 0.9;\r\n    transform: translateY(-1px);\r\n  }\r\n  .pswd_div .MuiInputAdornment-root , .labl_div .MuiInputAdornment-root {\r\n    margin-right: 28px;\r\n  }\r\n  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\r\n  \r\n    box-shadow: none !important;\r\n  }\r\n  .pswd_div .MuiInputBase-root {\r\n    /* padding-left: 0px !important; */\r\n  }\r\n  \r\n  /* Remove any yellow box-shadow on focus */\r\n  .MuiOutlinedInput-root.Mui-focused {\r\n    box-shadow: none !important;\r\n  }\r\n  input:-webkit-autofill,\r\ninput:-webkit-autofill:focus,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:active {\r\n  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;\r\n  box-shadow: 0 0 0 1000px #fff inset !important;\r\n  -webkit-text-fill-color: #222 !important;\r\n  caret-color: #222 !important;\r\n  transition: background-color 5000s ease-in-out 0s;\r\n}\r\n  \r\n  @media (max-width: 768px) {\r\n    .login-container {\r\n      flex-direction: column;\r\n    }\r\n  \r\n    .login-left {\r\n      padding: 2rem 1rem;\r\n    }\r\n  \r\n    .login-content h1 {\r\n      font-size: 2rem;\r\n    }\r\n  \r\n    .login-right {\r\n      padding: 1rem;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
